import { render, staticRenderFns } from "./TeachersTBD.vue?vue&type=template&id=32a03ae2&scoped=true&"
import script from "./TeachersTBD.vue?vue&type=script&lang=js&"
export * from "./TeachersTBD.vue?vue&type=script&lang=js&"
import style0 from "./TeachersTBD.vue?vue&type=style&index=0&id=32a03ae2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a03ae2",
  null
  
)

export default component.exports